import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ColumnFiltersState } from '@tanstack/react-table';

interface IntakeState {
  globalFilter: string;
  columnFilters: ColumnFiltersState;
}

const initialIntakeState: IntakeState = {
  globalFilter: '',
  columnFilters: [],
};

const intakesSlice = createSlice({
  name: 'intakes',
  initialState: initialIntakeState,
  reducers: {
    setIntakeGlobalFilter(state, action: PayloadAction<string>) {
      state.globalFilter = action.payload;
    },
    setIntakeColumnFilters(state, action: PayloadAction<ColumnFiltersState>) {
      state.columnFilters = action.payload;
    },
  },
});

export const { setIntakeGlobalFilter, setIntakeColumnFilters } =
  intakesSlice.actions;
export default intakesSlice.reducer;
